import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InstallationDetailsStore } from '@store';
import { DeviceRoles } from '@vi-iot/client';

@Injectable()
export class RemoteDiagnosticsBackupGuardService {
  constructor(private installationDetails: InstallationDetailsStore) {}

  canActivate(): Observable<boolean> {
    return this.installationDetails.hasSelectedDeviceGivenRoles([DeviceRoles.BackupCapability]);
  }
}
